/**
 * Scrolls the closest scrollable ancestor of `element` to its bottom.
 * Unlike `scrollIntoView`, it never scrolls the page when the list is not
 * inside its own scroll container (e.g. a chat panel rendered inline).
 */
export function scrollParentToBottom(
  element: HTMLElement | null,
  behavior: ScrollBehavior = "smooth",
): void {
  let node = element?.parentElement ?? null;
  while (node && node !== document.body) {
    const { overflowY } = window.getComputedStyle(node);
    const scrollable = overflowY === "auto" || overflowY === "scroll";
    if (scrollable && node.scrollHeight > node.clientHeight) {
      node.scrollTo({ top: node.scrollHeight, behavior });
      return;
    }
    node = node.parentElement;
  }
}
